import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "snackbar__controls" }

import { computed, ref, onMounted } from 'vue';

import SmTextButton from '@/components/ui/buttons/SmTextButton/SmTextButton.vue';
import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';

import { ISnackbarProps } from '@/@types/components/ui/notifications';

import '@/components/ui/notifications/TheSnackbar/style.scss';

// [START] Props

export default /*#__PURE__*/_defineComponent({
  __name: 'TheSnackbar',
  props: {
    id: {},
    message: {},
    duration: {},
    vertical: { type: Boolean },
    action: {},
    showClose: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }) {

const props = __props;


// [END] Props

// [START] Emits

// [END] Emits

// [START] Variables
const timer = ref<number | ReturnType<typeof setTimeout>>(-1);
const startedAt = ref<number>(0);
// [END] Variables

// [START] Computed
const classList = computed(() => (props.vertical ? ' snackbar--vertical' : ''));
// [END] Computed

// [START] Hooks
onMounted(() => {
  if (props.duration) {
    startedAt.value = Date.now();
    timer.value = setTimeout(handleClose, props.duration);
  }
});
// [END] Hooks

// [START] Methods
const handleAction = () => {
  props.action?.handler();
};

const handleClose = () => {
  emits('close');
};
// [END] Methods

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['snackbar', classList.value])
  }, [
    _createElementVNode("p", {
      class: "snackbar__message",
      innerHTML: _ctx.message
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.action)
        ? (_openBlock(), _createBlock(SmTextButton, {
            key: 0,
            type: "primary",
            class: "snackbar__action",
            onClick: handleAction
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.action.title), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showClose)
        ? (_openBlock(), _createBlock(SmIcon, {
            key: 1,
            name: "Cross",
            size: "12",
            class: "snackbar__icon",
            onClick: handleClose
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})